'use client';

const TITLE_TOP_OFFSET = 100;

function splitHeadingStatement(text: string) {
  if (text.toLowerCase().includes('protecting')) {
    const index = text.toLowerCase().indexOf('protecting');
    const firstPart = text.substring(0, index + 'protecting'.length).trim();
    const secondPart = text.substring(index + 'protecting'.length).trim();
    return { firstPart, secondPart };
  }
  // Split after the second word so the first line has two words (e.g. "Building teams")
  const firstSpaceIndex = text.indexOf(' ');
  if (firstSpaceIndex > 0) {
    const afterFirstWord = text.substring(firstSpaceIndex + 1);
    const secondSpaceIndex = afterFirstWord.indexOf(' ');
    if (secondSpaceIndex > 0) {
      return {
        firstPart: text.substring(0, firstSpaceIndex + 1 + secondSpaceIndex).trim(),
        secondPart: afterFirstWord.substring(secondSpaceIndex).trim(),
      };
    }
    // Only one word total or two words; keep single split
    return {
      firstPart: text.substring(0, firstSpaceIndex),
      secondPart: text.substring(firstSpaceIndex).trim(),
    };
  }
  return { firstPart: text, secondPart: '' };
}

export interface ServicePageTitleProps {
  heading: string;
  headingStatement?: string;
  headingStatementLines?: string[];
}

export function ServicePageTitle({ heading, headingStatement = '', headingStatementLines }: ServicePageTitleProps) {
  const parts = headingStatementLines?.length
    ? { firstPart: headingStatementLines[0], secondPart: headingStatementLines.slice(1).join(' ') }
    : splitHeadingStatement(headingStatement);

  const statementLines =
    headingStatementLines ?? (parts.firstPart ? [parts.firstPart, parts.secondPart].filter(Boolean) : []);

  return (
    <>
      <div className="relative z-10 h-[120px] tablet:h-[100px]" aria-hidden />
      <div className="relative z-10 w-full pb-4 pt-0">
        <div className="mx-auto max-w-full px-4 tablet:max-w-[1200px]">
          <div className="mx-auto w-full tablet:max-w-[1200px]">
            {statementLines.length > 0 && (
              <div className="mb-4 text-center">
                <h1 className="font-breit text-serviceHeroStatement font-bold leading-none tracking-serviceHeroStatement text-white">
                  {statementLines.map((line, i) => (
                    <span key={i} className="block">
                      {line}
                    </span>
                  ))}
                </h1>
              </div>
            )}
            {heading && (
              <p
                className="text-center font-breit text-serviceHeroEyebrow font-normal uppercase leading-[120%] text-at"
                style={{ textShadow: '0 0 24px #192836' }}
              >
                {heading.toUpperCase()}
              </p>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
